var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPiccolo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6698_109416",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6698_109416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 25.3333V12.4999C4.75 11.9444 4.90556 11.4388 5.21667 10.9833C5.52778 10.5277 5.93889 10.1999 6.45 9.99993L20.2833 4.69993C20.7278 4.52215 21.1389 4.5666 21.5167 4.83326C21.8944 5.09993 22.0833 5.4666 22.0833 5.93326V15.9999H23.4167C23.4167 15.2666 23.6778 14.6388 24.2 14.1166C24.7222 13.5944 25.35 13.3333 26.0833 13.3333C26.8167 13.3333 27.4444 13.5944 27.9667 14.1166C28.4889 14.6388 28.75 15.2666 28.75 15.9999V25.3333C28.75 26.0666 28.4889 26.6944 27.9667 27.2166C27.4444 27.7388 26.8167 27.9999 26.0833 27.9999H7.41667C6.68333 27.9999 6.05556 27.7388 5.53333 27.2166C5.01111 26.6944 4.75 26.0666 4.75 25.3333ZM7.41667 25.3333H12.75V18.6666C12.75 17.9333 13.0111 17.3055 13.5333 16.7833C14.0556 16.261 14.6833 15.9999 15.4167 15.9999H19.4167V7.8666L7.41667 12.4999V25.3333ZM15.4167 25.3333H19.4167V22.6666C19.4167 22.2888 19.5444 21.9722 19.8 21.7166C20.0556 21.461 20.3722 21.3333 20.75 21.3333C21.1278 21.3333 21.4444 21.461 21.7 21.7166C21.9556 21.9722 22.0833 22.2888 22.0833 22.6666V25.3333H26.0833V18.6666H15.4167V25.3333Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiccolo);
export default __webpack_public_path__ + "static/media/piccolo.b70f96251ac57d6da917539e724699a7.svg";
export { ForwardRef as ReactComponent };